import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	overviewLimitReached: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached',
		defaultMessage:
			"You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}",
		description:
			'Warning message displayed when user tries to create an overview but has reached the maximum limit allowed.',
	},
});
